export default "__VITE_ASSET__Dw3kSxnV__"